var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"layout"},[_c('Header',{staticClass:"layout-header"},[_c('TopHeader',{attrs:{"showLogo":""}})],1),_vm._v(" "),_c('Content',{staticClass:"layout-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }